import { Outlet } from "react-router-dom";
import NotFound from "../Views/Pages/Notfound";
import Logout from "../Views/Components/LogOut";
import IFrameAgent from "../Views/Pages/IFrameAgent";
import IFrameMultiAgent from "../Views/Pages/IFrameMultiAgent";
import IFrameWorkFlow from "../Views/Pages/iFrameWorkFlow";

const MaintenanceRoute = {
    path: "/",
    // element: <Outlet />,
    element: (
        <>
            <Outlet />
        </>
    ),
    children: [
        {
            path: '/logout',
            element: <Logout />
        },
        {
            path: '/iframeAgent/:agentId/:apiKey',
            element: <IFrameAgent />
            // element: <IFrame />
        },
        {
            path: '/iframeMultiAgent/:teamsId/:apiKey',
            element: <IFrameMultiAgent />
        },
        {
            path: '/iframeWorkflow/:workflowId/:apiKey',
            element: <IFrameWorkFlow />
        },
        {
            path: '*',
            element: <NotFound />
        },


    ]

}

export default MaintenanceRoute